import React, { useEffect } from "react";
import { reduxForm, Field, getFormValues } from "redux-form";
import { useDispatch, connect, useSelector } from "react-redux";
import {
	StepButtons,
	CustomInput,
	RequiredMark,
	PhoneInputRedux,
} from "components";
import { Row, Col, Form } from "react-bootstrap";
import { BusinessTaxSelect } from "components/select/businessTaxSelect";
import styles from "../stepper.module.scss";
import {
	validateEmail,
	validateBusinessTaxFilling,
	validateWhenTypeOfBusinessIsOther,
} from "./validation";
import {
	maxLengthPhone14,
	minLengthPhone8,
	required,
	trim,
	trimMidSentence,
} from "validators";
import { businessActions, uiActions } from "store";
import { typeOfBusiness } from "helpers/dropdownValues";

const formName = "business";

let BusinessStep = ({
	prevStep,
	nextStep,
	handleSubmit,
	submitting,
	formValues,
	token,
}) => {
	// const loadBusinessTaxFilling = async () => [{ value: "", label: "" }];
	const dispatch = useDispatch();

	useEffect(() => {
		if (submitting) {
			dispatch(uiActions.showSpinnerOverlay());
		}
		return () => dispatch(uiActions.hideSpinnerOverlay());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [submitting]);

	const applicationId = useSelector(state => state.generalInfo.applicationId);

	const saveBusiness = values => {
		return dispatch(
			businessActions.sendBusiness({ ...values, token, applicationId }),
		).then(nextStep);
	};

	return (
		<form onSubmit={handleSubmit(saveBusiness)} className={styles.form}>
			<Row>
				<Col lg={6} md={12}>
					<Field
						component={CustomInput}
						name="email"
						label="Business Contact Email"
						validate={validateEmail}
						normalizeOnBlur={trim}
						normalize={trimMidSentence}
						tabIndex={1}
					/>
					<Form.Group as={Row}>
						<Form.Label column sm={6}>
							Business Tax Filling
							<RequiredMark />
						</Form.Label>
						<Col sm={6}>
							<Field
								component={BusinessTaxSelect}
								name="typeOfBusiness"
								options={typeOfBusiness}
								validate={validateBusinessTaxFilling}
								tabIndex={3}
							/>
						</Col>
					</Form.Group>
					<Field
						component={CustomInput}
						name="businessIfOther"
						label="Other Business Tax Filling"
						validate={validateWhenTypeOfBusinessIsOther}
						normalizeOnBlur={trim}
						normalize={trimMidSentence}
						tabIndex={4}
						disabled={formValues.typeOfBusiness !== "Other"}
					/>
				</Col>
				<Col lg={6} md={12}>
					<Field
						component={PhoneInputRedux}
						name="phone"
						label="Business / Office Phone"
						isRequired
						validate={[required, minLengthPhone8, maxLengthPhone14]}
						formName={formName}
					/>
				</Col>
			</Row>
			<StepButtons
				nextStep={nextStep}
				prevStep={prevStep}
				initialTabIndex={5}
			/>
		</form>
	);
};

BusinessStep = reduxForm({
	form: formName,
	destroyOnUnmount: false,
})(BusinessStep);

const mapStateToProps = state => ({
	formValues: getFormValues(formName)(state) || {},
});

BusinessStep = connect(mapStateToProps)(BusinessStep);

export { BusinessStep };
